module.exports = __webpack_public_path__ + "assets/img/img-footer-use03.svg";